
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetodapoliinnovacrystacabservice() {



    const cardData =
    {
        keyword: 'Pune to Dapoli Innova Crysta Cab Service',
        heading: 'Meghana Cab : Pune to Dapoli Innova Crysta Cab Service',
        headingDescription: 'Meghana Cab offers Pune to Dapoli Innova Crysta Cab Service, providing a luxurious, spacious, and reliable travel experience to one of Maharashtra’s most serene coastal destinations. Whether you are planning a relaxing beach vacation, a weekend getaway, or a family trip, our Innova Crysta vehicles ensure maximum comfort with premium interiors, ample legroom, and generous luggage space.',


        top: 'Top Places to Visit in Dapoli with Meghana Cab',

"topPlaces": [
  {
    "title": "Ladghar Beach",
    "description": "Renowned for its unique red-hued sand and calm waters, Ladghar Beach is perfect for parasailing, dolphin-spotting, and evening strolls. Often referred to as Tamas Teertha, this beach comes alive with vibrant sunsets and is a hub for water-sport enthusiasts and relaxing family outings."  
  },
  {
    "title": "Karde Beach",
    "description": "A serene, golden-sand beach stretching over 4 km, Karde offers swimming, bird-watching, and dolphin sightings in near solitude. Backed by coconut groves and minimal crowd, it’s an ideal spot for seaside picnics, stargazing, and unwinding far from tourist bustle."  
  },
  {
    "title": "Murud (Harnai) Beach & Port",
    "description": "A mix of black-sand shoreline and rolling hills, Murud Beach is adjacent to Harnai Port—a picturesque fishing harbor where local catch is auctioned fresh. Enjoy beach rides, dolphin cruises, and explore the historic Durga Devi temple in nearby Murud village."  
  },
  {
    "title": "Kolthare Beach",
    "description": "An offbeat gem near Kolthare village, this unspoiled beach features pristine sands and a peaceful Shiva temple. Far from crowds, Kolthare offers serene sunset views, safe swimming, and ideal settings for picnics or meditation."  
  },
  {
    "title": "Unhavare Hot Springs",
    "description": "About 35 km from Dapoli, these therapeutic sulphur-rich hot springs are famed for skin benefits. Set in lush green surroundings, the baths are sheltered and warm—perfect after a day of sightseeing."  
  },
  {
    "title": "Panhalekaji Caves",
    "description": "A group of 29 rock-cut Buddhist caves located on the Kotjai River bank. Each cave features detailed artistry depicting deities and tales from ancient epics. Quiet and less crowded, it’s a historical delight set among coconut-clad hills."  
  },
  {
    "title": "Keshavraj Temple",
    "description": "Nestled in thick greenery about 6 km from Dapoli, this temple dedicated to Lord Vishnu sits next to a perennial stream. Reachable via a scenic trek, it’s a peaceful spot revered for its spiritual ambience and natural setting."  
  },
  {
    "title": "Kadyavarcha Ganapati Temple (Anjarle)",
    "description": "Near Anjarle village, this 11th-century temple houses a rare right-trunked Ganesha idol. Located by a creek with boats and a lush environment, it's a culturally rich destination with limited tourism yet deep local significance."  
  },
  {
    "title": "Parshuram Bhumi",
    "description": "A dramatic hilltop landmark near Ladghar, featuring a 21-foot statue of Lord Parshuram on a globe pedestal. The viewpoint offers sweeping vistas of red-sand beaches and coconut groves—perfect for photography and peaceful contemplation."  
  },
  {
    "title": "Suvarnadurg & Goa Sea Forts",
    "description": "Accessible via boat from Harnai Port, Suvarnadurg is an imposing sea fort built by Shivaji. Nearby Goa and Kanakdurg forts are smaller coastal bastions with ruins and cannon remnants—offering immersive history and serene backdrops."  
  }
],

  "services": [
    {
      "name": "Pune to Dapoli Innova Crysta Cab Booking",
      "description": "Book a premium Innova Crysta cab from Pune to Dapoli for a scenic and comfortable coastal getaway. Our service ensures a smooth and relaxed travel experience with well-maintained vehicles, courteous drivers, and flexible travel options tailored for families, groups, and business trips."
    },
    {
      "name": "One Way Innova Crysta Pune Dapoli",
      "description": "Planning a one-way trip to Dapoli? Our one-way Innova Crysta service from Pune offers convenience, cost-efficiency, and reliable travel without the obligation of booking a return ride. Ideal for vacations, short stays, or drop-offs at resorts and hotels."
    },
    {
      "name": "Round Trip Innova Crysta Pune Dapoli",
      "description": "Choose our round-trip Innova Crysta cab service for a complete Pune to Dapoli travel package. Enjoy the flexibility of staying as long as you want, with your driver and vehicle waiting to bring you back comfortably at your convenience."
    },
    {
      "name": "AC Innova Crysta Taxi Pune Dapoli",
      "description": "Travel in style and comfort in our fully air-conditioned Innova Crysta taxi from Pune to Dapoli. Our vehicles offer a smooth ride and climate-controlled interiors, perfect for long-distance drives through the coastal routes of Maharashtra."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Pune Dapoli",
      "description": "Relax while our professional chauffeurs handle the drive from Pune to Dapoli. Our chauffeur-driven Innova Crysta cabs offer safe, punctual, and courteous service, making your journey comfortable and worry-free."
    },
    {
      "name": "Private Innova Crysta Taxi Pune Dapoli",
      "description": "Enjoy your own private space during the journey with our exclusive Innova Crysta taxi from Pune to Dapoli. No ride-sharing—just you, your companions, and a smooth, uninterrupted trip tailored to your schedule and preferences."
    },
    {
      "name": "Online Booking Innova Crysta Cab Pune Dapoli",
      "description": "Easily book your Innova Crysta cab online for your Pune to Dapoli journey. Our digital platform offers real-time availability, instant confirmation, secure payments, and full transparency on fares and travel details."
    },
    {
      "name": "Family Innova Crysta Trip Pune Dapoli",
      "description": "Make your family trip to Dapoli comfortable and memorable with our spacious 6/7-seater Innova Crysta. With ample space for passengers and luggage, it’s perfect for long drives, beachside holidays, and weekend retreats."
    }
  ],
  "tableData": [
    ["Pune to Dapoli Innova Crysta Cab Booking", "One Way Innova Crysta Pune Dapoli"],
    ["Round Trip Innova Crysta Pune Dapoli", "AC Innova Crysta Taxi Pune Dapoli"],
    ["Chauffeur Driven Innova Crysta Pune Dapoli", "Private Innova Crysta Taxi Pune Dapoli"],
    ["Online Booking Innova Crysta Cab Pune Dapoli", "Family Innova Crysta Trip Pune Dapoli"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Comfortable Innova Crysta Cab from Pune to Dapoli",
    "WhyChoosedescription": "Travel from Pune to the serene coastal town of Dapoli in a spacious and luxurious Innova Crysta. Whether it’s a family vacation, weekend escape, or group trip, our cab service offers comfort, safety, and reliability for your entire journey."
  },
  {
    "WhyChooseheading": "Spacious Interiors and Premium Comfort",
    "WhyChoosedescription": "Our Innova Crysta cabs feature plush, reclining seats, rear AC vents, and ample luggage space—ideal for long drives through the Western Ghats to Dapoli. Travel stress-free with seating for up to 6–7 passengers and premium in-cabin comfort."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Coastal Routes",
    "WhyChoosedescription": "Our professional drivers are well-versed with the Pune to Dapoli route, including the ghat sections and scenic detours. They ensure a safe, smooth, and efficient ride, while also accommodating breaks and local recommendations along the way."
  },
  {
    "WhyChooseheading": "Well-Maintained, Sanitized Vehicles for Safe Travel",
    "WhyChoosedescription": "All our Innova Crysta vehicles undergo routine servicing and full sanitization before every trip. We maintain high standards of cleanliness and safety, making them perfect for families, children, and elderly travelers."
  },
  {
    "WhyChooseheading": "Customizable Trip Plans and Itineraries",
    "WhyChoosedescription": "Choose from one-way, round-trip, or multi-day rental packages. Customize your travel timings, pickup and drop locations, and request en route stops at attractions like Karde Beach, Anjarle, or Murud if desired."
  },
  {
    "WhyChooseheading": "Transparent and Fair Pricing",
    "WhyChoosedescription": "Our pricing includes driver allowances, tolls, fuel, and taxes—ensuring complete transparency with no hidden charges. Get premium cab service at competitive rates that suit your travel budget."
  },
  {
    "WhyChooseheading": "Ideal for Coastal Holidays, Family Travel, and Small Groups",
    "WhyChoosedescription": "Whether you're heading to a beach resort, holiday homestay, or just enjoying the Konkan coast, the Innova Crysta offers the perfect balance of space, comfort, and luxury for up to 6–7 travelers."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Assistance",
    "WhyChoosedescription": "Book your Pune to Dapoli cab online or through our helpline anytime. Our support team is available 24/7 to help with itinerary planning, urgent bookings, or last-minute changes to your travel schedule."
  }
]





















    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Dapoli?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or through our website for a quick and smooth booking process."
    },
    {
        question: "What is the distance and travel time from Pune to Dapoli?",
        answer: "The distance from Pune to Dapoli is approximately 190 km, with an average travel time of around 5 to 6 hours depending on road conditions."
    },
    {
        question: "Is Innova Crysta a good choice for long-distance travel like Pune to Dapoli?",
        answer: "Yes, the Innova Crysta offers excellent comfort, spacious seating, and smooth handling, making it ideal for long-distance journeys."
    },
    {
        question: "Can I book a one-way or round trip from Pune to Dapoli?",
        answer: "Yes, we offer both one-way and round-trip options based on your travel needs."
    },
    {
        question: "How many passengers can travel in the Innova Crysta?",
        answer: "The vehicle can accommodate 6 to 7 passengers along with luggage comfortably."
    },
    {
        question: "Are the cabs sanitized before every trip?",
        answer: "Absolutely. All our cabs are sanitized thoroughly before every journey for your safety and hygiene."
    },
    {
        question: "Do your drivers have experience driving to coastal destinations like Dapoli?",
        answer: "Yes, our drivers are experienced with routes to Dapoli and similar coastal destinations and ensure a safe ride."
    },
    {
        question: "What is included in the fare for Pune to Dapoli Innova Crysta cab service?",
        answer: "The fare includes fuel, tolls, and driver charges. Any parking or extra waiting time may be billed additionally."
    },
    {
        question: "Is the service available for early morning or late-night departures?",
        answer: "Yes, Meghana Cab offers 24/7 cab services for your convenience, including early morning or late-night travel."
    },
    {
        question: "What are the accepted payment methods?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Suresh Jagtap',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta for a family trip to Dapoli. The cab was in excellent condition and the journey was very comfortable.”',
    },
    {
        name: 'Ms. Rutuja Desai',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Great service from Meghana Cab. Smooth ride to Dapoli in a clean and spacious Innova Crysta. Will book again!”',
    },
];





















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneDapoliInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Dapoli Innova Crysta Cab Service",
  "description": "Book AC Innova Crysta cab for Pune to Dapoli trips. One way and round trip options, chauffeur-driven, private and family-friendly taxi service with easy online booking.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation Taxi Service",
  "areaServed": [
    {
      "@type": "City",
      "name": "Pune"
    },
    {
      "@type": "City",
      "name": "Dapoli"
    }
  ],
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-dapoli-innova-crysta-cab"
  }
};




    return (
        <div>


<Helmet>
  <title>Pune to Dapoli Innova Crysta Cab Service | Meghana Cabs</title>
  <meta
    name="description"
    content="Reliable AC Innova Crysta taxi service from Pune to Dapoli. One way and round trip available. Chauffeur-driven, private, and family-friendly. Book online easily."
  />
  <meta
    name="keywords"
    content="Pune to Dapoli Innova Crysta Cab Booking, One Way Innova Crysta Pune Dapoli, Round Trip Innova Crysta Pune Dapoli, AC Innova Crysta Taxi Pune Dapoli, Chauffeur Driven Innova Crysta Pune Dapoli, Private Innova Crysta Taxi Pune Dapoli, Online Booking Innova Crysta Cab Pune Dapoli, Family Innova Crysta Trip Pune Dapoli"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneDapoliInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/30.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetodapoliinnovacrystacabservice;